import gql from 'graphql-tag'

export const SUBSCRIBE = gql`
  mutation subscribe($input: SubscriptionInput!) {
    subscribe(input: $input) {
      billingPlan {
        name
        subscribed
        expire
      }
    }
  }
`

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      billingPlan {
        name
        subscribed
        expire
        canceled
      }
    }
  }
`

export const RENEW_SUBSCRIPTION = gql`
  mutation renewSubscription($input: SubscriptionInput!) {
    renewSubscription(input: $input) {
      billingPlan {
        name
        subscribed
        expire
        canceled
      }
    }
  }
`
